import Vue from 'vue';
import Router from 'vue-router';
// 注册router页面规则
/** *
 * 1.除首页和三方调用页面外，其他页面均以动态注册的方式注册，
 * 如const A=()=>import('@/...')
 * 或
 children: [
 {
       path: '',
       name: '',
       component: (resolve) => require(['@/..'], resolve)
   },]
 *
 * 2.routes的元素，必须以模块为单位，其内部页面为模块的children[]
 * 3.尽量不要定义参数在routers,除非外部调用或者需要路由直接使用
 ****/
Vue.use(Router);
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};
const base = process.env.HOST === 'pre' ? 'tj_stage' : 'tj';
export default new Router({
  mode: 'history',
  base,
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/personal-center',
      name: '个人中心',
      component: () => import('@/pages/userinfo/index.vue'),
      children: [
        {
          path: 'userinfo',
          name: '个人信息',
          component: () => import('@/pages/userinfo/userinfo.vue')
        },
        {
          path: 'signature-maintenance',
          name: '签名维护',
          component: () => import('@/pages/userinfo/signature-maintenance.vue')
        }
      ]
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/pages/index.vue')
    },
    {
      path: '/divisional-list',
      name: '分案列表',
      meta: {
        keep: true,
        breadcrumb: [
          {
            name: '首页',
            to: {path: '/'}
          },
          {name: '待办批次'}
        ],
        replace: true
      },
      component: () => import('@/pages/divisional-list/index.vue')
    },
    {
      path: '/case-handling',
      name: '案件办理',
      meta: {
        keep: true,
        breadcrumb: [
          {
            name: '首页',
            to: {path: '/'}
          },
          {name: '案件办理'}
        ],
        replace: true
      },
      component: () => import('@/pages/case-handling/index.vue'),
      children: [
        {
          path: '/event-tracking',
          name: '短信发送失败',
          component: () => import('@/pages/case-handling/index.vue')
        }
      ]
    },
    {
      path: '/case-detail',
      name: '案件详情',
      meta: {
        breadcrumb: [
          {
            name: '首页',
            to: {path: '/'}
          },
          {
            name: '案件办理',
            to: {path: '/case-handling'}
          },
          {name: '案件编辑'}
        ],
        breadcrumbQuery: [
          {
            name: '首页',
            to: {path: '/'}
          },
          {
            name: '案件查询',
            to: {path: '/case-query'}
          },
          // {
          //   name: '归档案件',
          //   to: {path: '/case-filling'}
          // },
          {name: '案件详情'}
        ],
        breadcrumbFilling: [
          {
            name: '首页',
            to: {path: '/'}
          },
          {
            name: '归档案件',
            to: {path: '/case-filling'}
          },
          {name: '案件详情'}
        ]
      },
      component: () => import('@/pages/case-handling/pages/case-detail.vue')
    },
    {
      path: '/judicial-confirmation',
      name: '司法确认案件',
      component: () => import('@/pages/judicial-confirmation/index.vue')
    },
    {
      path: '/case-import',
      name: 'case-import',
      redirect: '/step-select-organ',
      component: () => import('@/pages/case-import/index.vue'),
      children: [
        {
          path: '/step-select-organ',
          name: '选择调解机构(必填)',
          component: () => import('@/pages/case-import/step-select-organ.vue')
        },
        {
          path: '/step-select-template',
          name: '选择申请人模板(必填)',
          component: () => import('@/pages/case-import/step-select-template.vue')
        },
        {
          path: '/step-import-case-information',
          name: '导入案件信息(必填)',
          component: () => import('@/pages/case-import/step-import-case-information.vue')
        },
        {
          path: '/step-set-plan',
          name: '预设还款方案',
          component: () => import('@/pages/case-import/step-set-plan.vue')
        },
        {
          path: '/step-import-case-material',
          name: '导入案件材料',
          component: () => import('@/pages/case-import/step-import-case-material.vue')
        }
      ]
    },

    // --------- 调解2.1-----------
    {
      path: '/brt-list',
      name: 'brt-list',
      component: () => import('@/pages/non-lawsuit/index.vue'),
      meta: {keep: true},
      children: [
        {
          path: 'fstj',
          name: '非诉调解',
          component: () => import('@/pages/non-lawsuit/non-lawsuit-list'),
          meta: {keep: true}
        },
        {
          path: 'sfqr',
          name: '司法确认',
          component: () => import('@/pages/non-lawsuit/judicial-confirmation-list'),
          meta: {keep: true}
        }
      ]
    },
    {
      path: '/brt-apply-judicial-confirmation',
      name: '申请司法确认',
      redirect: '/brt-apply-judicial-confirmation/brt-apply-court',
      component: () => import('@/pages/apply-judicial-confirmation/index.vue'),
      children: [
        {
          path: 'brt-apply-court',
          name: '申请法院',
          component: () => import('@/pages/apply-judicial-confirmation/apply-court.vue')
        },
        {
          path: 'brt-apply-template',
          name: '申请人模板',
          component: () => import('@/pages/apply-judicial-confirmation/apply-template.vue')
        },
        {
          path: 'brt-template-detail',
          name: '模板详情',
          component: () => import('@/pages/apply-judicial-confirmation/template-detail.vue')
        },
        {
          path: 'brt-yzw-template-detail',
          name: 'YZW模板详情',
          component: () => import('@/pages/apply-judicial-confirmation/yzw-template-detail.vue')
        }
      ]
    },
    {
      path: '/brt-judicial-confirmation-detail',
      name: '司法确认详情',
      component: () => import('@/pages/non-lawsuit/judicial-confirmation-detail')
    },
    {
      path: '/brt-yzw-judicial-confirmation-detail',
      name: 'YZW司法确认详情',
      component: () => import('@/pages/non-lawsuit/yzw-judicial-confirmation-detail')
    },
    {
      path: '/brt-unit-config',
      name: 'brt-unit-config',
      component: () => import('@/pages/non-lawsuit/unit-config.vue')
    },
    {
      path: '/brt-case-detail',
      name: 'brt-case-detail',
      component: () => import('@/pages/non-lawsuit/case-detail.vue')
    },
    // 文书配置
    {
      path: '/document-config',
      name: 'document-config',
      component: () => import('@/pages/non-lawsuit/document-config.vue'),
      meta: {
        breadcrumb: [
          {
            name: '首页',
            to: {path: '/'}
          },
          {name: '文书模板管理配置'}
        ]
      }
    },
    // 代理人端文书配置路由
    {
      path: '/brt-document-config',
      name: 'brt-document-config',
      component: () => import('@/pages/non-lawsuit/document-config.vue')
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('@/pages/organ-manager/form-generate-config/index.vue')
    },

    // 文书编辑
    {
      path: '/doc-edit-page',
      name: 'doc-edit-page',
      component: () => import('@/components/doc-editor/doc-edit-page.vue')
    },

    {
      path: '/upload-test',
      name: 'upload-test',
      component: () => import('@/pages/case-import/meterial-upload/material-batch-upload-dialog.vue')
    },
    // 调解2.2
    {
      path: '/video-ing',
      name: 'video-ing',
      component: () => import('@/pages/video-ing/index.vue')
    },
    // 调解2.5
    {
      path: '/case-query',
      name: '案件查询',
      meta: {
        keep: true,
        breadcrumb: [
          {
            name: '首页',
            to: {path: '/'}
          },
          {name: '案件查询'}
        ],
        replace: true
      },
      component: () => import('@/pages/case-manager/case-query')
    },
    {
      path: '/case-back',
      name: '案件退回',
      meta: {
        keep: false,
        breadcrumb: [
          {
            name: '首页',
            to: {path: '/'}
          },
          {name: '案件退回'}
        ],
        replace: true
      },
      component: () => import('@/pages/case-back/case-back.vue')
    },
    {
      path: '/case-back-list',
      name: '案件退回记录',
      meta: {
        keep: false,
        breadcrumb: [
          {
            name: '首页',
            to: {path: '/'}
          },
          {name: '案件撤回/退回记录'}
        ],
        replace: true
      },
      component: () => import('@/pages/case-back/case-back-list.vue')
    },
    {
      path: '/case-filling',
      name: '归档案件',
      meta: {
        keep: true,
        breadcrumb: [
          {
            name: '首页',
            to: {path: '/'}
          },
          {name: '归档案件'}
        ],
        replace: true
      },
      component: () => import('@/pages/case-manager/case-filling-list')
    },
    {
      path: '/mediation-cloud-chart',
      name: '调解云图',
      component: () => import('@/pages/case-manager/mediation-cloud-chart')
    },
    {
      path: '/statistical-analysis',
      name: '统计报表',
      meta: {
        breadcrumb: [
          {
            name: '首页',
            to: {path: '/'}
          },
          {name: '统计报表'}
        ]
      },
      component: () => import('@/pages/case-manager/statistical-analysis')
    },
    // 站内信
    {
      path: '/brt-mail-management',
      name: 'brt-mail-management',
      component: () => import('@/pages/station-information-management/index.vue'),
      meta: {
        keep: false,
        breadcrumb: [
          {
            name: '首页',
            to: {path: '/'}
          },
          {name: '站内信管理'}
        ]
      }
    },
    // 公告list
    {
      path: '/adView',
      name: 'adViewPage',
      component: (resolve) => require(['@/components/common/adview/adViewPage.vue'], resolve)
    },
    // 信息验证配置
    {
      path: '/information-verification-config',
      name: '信息验证配置',
      component: (resolve) => require(['@/pages/organ-manager/components/information-verification-config.vue'], resolve)
    },
    // 文书编辑预览
    {
      path: '/document-edit-and-preview',
      name: '文书编辑',
      component: (resolve) => require(['@/pages/document-edit/index.vue'], resolve)
    },
    // 运营平台跳转路由，如果没有单独的，就跳到这里，然后再分发
    {
      path: '/operation-admin',
      name: '运营平台',
      component: (resolve) => require(['@/pages/operation-admin/index.vue'], resolve)
    },
    // name字段有判断，如果需要修改，请全局搜索一下内容。
    {
      path: '/organ-manager',
      name: '机构管理员模块中心',
      component: (resolve) => require(['@/pages/operation-admin/index.vue'], resolve)
    },
    {
      path: '/md-organ-manager',
      name: '机构管理员模块中心3.0',
      meta: {
        isMd: true,
      },
      component: (resolve) => require(['@/pages/operation-admin/index.vue'], resolve)
    },
    {
      path: '/recording-association',
      name: 'recordingAssociation',
      component: () => import('@/pages/recording-association/index.vue'),
      meta: {
        breadcrumb: [
          {
            name: '首页',
            to: {path: '/'}
          },
          {name: '录音关联'}
        ]
      }
    },
    // 代理人端-文书签收
    {
      path: '/brt-document-sign',
      name: 'document-sign',
      component: () => import('@/pages/non-lawsuit/document-sign.vue'),
      redirect: '/brt-document-sign/fstj',
      children: [
        {
          path: 'fstj',
          name: 'fstj',
          component: () => import('@/pages/non-lawsuit/document-sign-fstj.vue'),
        },
        {
          path: 'sfqr',
          name: 'sfqr',
          component: () => import('@/pages/non-lawsuit/document-sign-sfqr.vue'),
        }
      ]
    },
    {
      path: '/case-signature',
      name: 'caseSignature',
      component: () => import('@/pages/case-signature/index.vue'),
      meta: {
        breadcrumb: [
          {
            name: '首页',
            to: {path: '/'}
          },
          {name: '文书签字'}
        ]
      }
    },
    {
      path: '/batch-stamp',
      name: 'batchStamp',
      component: () => import('@/pages/batch-stamp/index.vue'),
      meta: {
        breadcrumb: [
          {
            name: '首页',
            to: {path: '/'}
          },
          {name: '批量签章'}
        ]
      }
    },
    // 保融通金融纠纷案件管理系统
    {
      name: 'brt-ag-admin',
      path: '/brt-ag',
      component: () => import('@/pages/brt/index'),
      redirect: '/brt-ag/main',
      children: [
        {
          // 首页
          name: 'brt-ag-main',
          path: '/brt-ag/main',
          component: () => import('@/pages/brt/main/index'),
          redirect: '/brt-ag/main/home',
          children: [
            {
              name: 'brt-ag-home',
              path: '/brt-ag/main/home',
              redirect: '/brt-ag/main/home/index',
              component: () => import('@/pages/brt/home/index'),
              meta: {menu: 'brtHome'},
              children: [
                {
                  name: 'brt-ag-home-statistics',
                  path: '/brt-ag/main/home/index',
                  component: () => import('@/pages/brt/home/index-statistics'),
                  meta: {menu: 'brtHome'},
                },
                {
                  name: 'brt-ag-home-litigation-more',
                  path: '/brt-ag/main/litigation-more',
                  component: () => import('@/pages/brt/home/litigation-more'),
                  meta: {menu: 'brtHome'},
                },
                {
                  name: 'brt-ag-home-mediate-more',
                  path: '/brt-ag/main/mediate-more',
                  component: () => import('@/pages/brt/home/mediate-more'),
                  meta: {menu: 'brtHome'},
                },
              ]
            },
            {
              path: 'signing-trends',
              name: '签约动态',
              component: () => import('@/pages/brt/signing-trends/signing-trends.vue'),
              meta: {menu: 'brtSignDynamic'},
            },
            {
              path: 'case-summary-table',
              name: '案件总表',
              redirect: 'case-summary-table/progress-case',
              component: () => import('@/pages/brt/case-summary-table/index.vue'),
              children: [
                {
                  path: 'progress-case',
                  name: '在办',
                  component: () => import('@/pages/brt/case-summary-table/progress-case.vue'),
                  meta: {keep: true, menu: 'brtCaseSummaryTable'},
                },
                {
                  path: 'completed-case',
                  name: '办结',
                  component: () => import('@/pages/brt/case-summary-table/completed-case.vue'),
                  meta: {keep: true, menu: 'brtCaseSummaryTable'},
                },
                {
                  path: 'batch-list',
                  name: '办结下钻',
                  component: () => import('@/pages/brt/case-summary-table/batch-list.vue'),
                  meta: {menu: 'brtCaseSummaryTable'},
                }
              ]
            },
            {
              path: 'litigation-statistics-table',
              name: '诉讼统计表',
              component: () => import('@/pages/brt/statistics-report/litigation-report.vue'),
              meta: {menu: 'brtProceedingStatistics'},
            },
            {
              path: 'mediate-statistics-table',
              name: '调解统计表',
              component: () => import('@/pages/brt/statistics-report/mediate-report.vue'),
              meta: {menu: 'brtMediateStatistics'},
            }
          ],
        },
        {
          // 个人中心
          name: 'brt-ag-user',
          path: '/brt-ag/user',
          component: () => import('@/pages/brt/user/index'),
          redirect: '/brt-ag/user/info',
          children: [
            {
              // 个人资料
              name: 'brt-ag-user-info',
              path: '/brt-ag/user/info',
              component: () => import('@/pages/brt/user/userInfo'),
              meta: {menu: 'brtUserInformation'},
            },
            {
              // 调解动态配置
              name: 'brt-ag-mediate-config',
              path: '/brt-ag/user/mediate-config',
              component: () => import('@/pages/brt/user/mediate-config'),
              meta: {menu: 'brtUserMediateConfig'},
            }
          ]
        },
        {
          // 404
          name: 'brt-ag-no-right',
          path: '/brt-ag/no-right',
          component: () => import('@/pages/nodata')
        }
      ]
    },
    {
      path: '/case-details-table',
      name: '案件详情表',
      component: () => import('@/pages/brt/case-summary-table/case-detail-table'),
    },
    {
      path: '/signing-today',
      name: '今日签约',
      component: () => import('@/pages/brt/signing-trends/signing-today'),
    },
    {
      path: '/custom-form',
      name: 'custom-form',
      component: () => import('@/pages/organ-manager/form-generate-config/index.vue')
    },
    {
      path: '/repair-phone/:status',
      name: '失联修复工具',
      component: () => import('@/pages/brt/repair-phone/index'),
    },
    {
      path: '/jby/:status',
      name: '交办云',
      component: () => import('@/pages/jby/index'),
    },
    {
      path: '/organ-rank/',
      name: '机构排名',
      component: () => import('@/pages/case-manager/organ-rank/index.vue'),
    },
    // {
    //   path: '/information-config',
    //   name: '要素配置',
    //   component: () => import('@/pages/dynamics-element/element-config.vue')
    // },
    {
      path: '/form-excel-map',
      name: '映射关系表',
      component: () => import('@/pages/dynamics-element/form-excel-map.vue'),
    },
    {
      path: '/pre-mediation',
      name: '先行调解',
      meta: {keep: true, },
      component: () => import('@/pages/pre-mediation/index.vue'),
    },
    {
      path: '/pre-mediation-detail',
      name: '先行调解详情',
      component: () => import('@/pages/pre-mediation/case-detail.vue'),
    },
  ]
});
